module.exports = __webpack_public_path__ + "img/img1.a1f29f3e.jpg";